<!-- components/NetworkWarning.vue -->
<template>
  <Teleport to="body">
    <!-- Minimal Uyarı -->
    <Transition name="slide-down">
      <div
        v-if="showWarning"
        class="fixed h-16 top-2 left-64 bg-white rounded-lg shadow-md border-l-4 p-2 max-w-[800px] z-50"
        :class="borderColor"
      >
        <div class="flex items-start gap-2">
          <!-- Durum ikonu -->
          <div class="w-3 h-3 rounded-full flex-shrink-0 mt-0.5" :class="statusColor"></div>

          <!-- Mesaj içeriği -->
          <div class="flex-1 min-w-0">
            <h4 class="text-xs font-medium text-gray-900">{{ warningTitle }}</h4>
            <p class="text-xs text-gray-600 mt-1 leading-relaxed">{{ warningMessage }}</p>
            <!-- <div class="text-xs text-gray-500 mt-1">{{ networkData.speed }} Mbps</div> -->
          </div>

          <!-- Kapatma butonu (sadece slow için) -->
          <button
            v-if="networkData.status === 'slow'"
            @click="dismissWarning"
            class="w-6 h-6 text-gray-400 hover:text-gray-600 -mt-4 border-none focus:outline-none focus:ring-0"
          >
            <svg viewBox="0 0 20 20" fill="currentColor" class="w-6 h-6">
              <path
                d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z"
              />
            </svg>
          </button>

          <!-- Kritik durum ikonu (çok yavaş/offline için) -->
          <div
            v-if="networkData.status === 'very-slow' || networkData.status === 'offline'"
            class="w-4 h-4 text-red-500 flex-shrink-0"
          >
            <svg viewBox="0 0 20 20" fill="currentColor" class="w-full h-full">
              <path
                fill-rule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zM9.25 13a.75.75 0 011.5 0v.01a.75.75 0 01-1.5 0V13z"
                clip-rule="evenodd"
              />
            </svg>
          </div>
        </div>
      </div>
    </Transition>

    <!-- Küçük durum göstergesi -->
    <!-- <div
      v-if="!showWarning && isMonitoring"
      class="fixed top-4 right-4 w-3 h-3 cursor-pointer z-40"
      @click="showDetails = !showDetails"
    >
      <div
        class="w-full h-full rounded-full transition-all duration-300"
        :class="indicatorColor"
      ></div>

      <!-- Tooltip -->
    <!-- <Transition name="fade">
        <div
          v-if="showDetails"
          class="absolute top-4 right-0 bg-black text-white px-2 py-1 rounded text-xs whitespace-nowrap"
        >
          {{ networkData.speed }} Mbps
        </div>
      </Transition>
    </div> -->
  </Teleport>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useNetworkSpeed } from '@/composables/useNetworkSpeed';

// isMonitoring
const { networkData, showWarning, dismissWarning } = useNetworkSpeed();
// const showDetails = ref(false);


const warningTitle = computed(() => {
  switch (networkData.value.status) {
    case 'offline':
      return 'Bağlantı Kesildi';
    case 'very-slow':
      return 'Çok Yavaş Bağlantı';
    case 'slow':
      return 'Yavaş Bağlantı';
    default:
      return 'Bağlantı Durumu';
  }
});

const warningMessage = computed(() => {
  switch (networkData.value.status) {
    case 'offline':
      return 'İnternet bağlantınız kesildi. Lütfen bağlantınızı kontrol edin.';
    case 'very-slow':
      return 'İnternet hızınız kritik seviyede düşük. Uygulama düzgün çalışmayabilir. ';
    case 'slow':
      return 'İnternet hızınız düşük. Bağlantınızı kontrol edin veya daha stabil bir ağa geçiş yapın. ';
    default:
      return '';
  }
});

const borderColor = computed(() => {
  switch (networkData.value.status) {
    case 'offline':
      return 'border-l-red-500';
    case 'very-slow':
      return 'border-l-red-500';
    case 'slow':
      return 'border-l-amber-500';
    default:
      return 'border-l-gray-300';
  }
});

const statusColor = computed(() => {
  switch (networkData.value.status) {
    case 'offline':
      return 'bg-red-500';
    case 'very-slow':
      return 'bg-red-500';
    case 'slow':
      return 'bg-amber-500';
    default:
      return 'bg-gray-400';
  }
});

</script>

<style scoped>
.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.2s ease;
}

.slide-down-enter-from {
  opacity: 0;
  transform: translateY(-10px);
}

.slide-down-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
